import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddUserModalComponent } from '../add-user-modal/add-user-modal.component';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { EditorService } from 'src/app/shared/services/editor.service';
import { ToastrService } from 'ngx-toastr';
import { ThemingService } from 'src/app/shared/services/theming.service';


@Component({
    selector: 'app-team',
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.scss'],
})

export class TeamComponent implements OnInit {

    panelOpenState = false;
    uid: string = "";
    teamName: string = "";
    teams: any[] = [];
    theme: boolean = true;
    objectKeys = Object.keys;

    constructor(private modal: NgbModal,
        private cookieServ: CookieService,
        private router: Router,
        private editorService: EditorService,
        private themingService:ThemingService,
        private toastr: ToastrService) {
            this.themingService.getThemeName().subscribe((res: any) => {
                this.theme = res;
              })
         }


    ngOnInit(): void {
        this.themingService.pingThemeName();

        this.uid = this.cookieServ.get("uid");
        // this.uid = "u-cf1f0bba-de69-11ed-bc06-7738ed7ada70";
        if (!this.uid) {
            this.router.navigate([`login`])
        } else {
            this.getTeam();
        }
    }

    openAddUserModel(tid: string) {
        const modalRef = this.modal.open(AddUserModalComponent,
            { centered: true, windowClass: 'TeamModal' });
        modalRef.componentInstance.uid = this.uid;
        modalRef.componentInstance.tid = tid;
        modalRef.result.then(e => {
            if (!!e && !!e?.data) {
                this.getTeam();
            }
        })
    }
    createTeam() {
        this.editorService.createAndGetTeam(
            {
                "uid": this.uid,
                "type": "create",
                "team-name": this.teamName
            }
        ).subscribe(res => {
            if (!!res && res.error) {
                this.toastr.error(res.error)
            }
            if (!!res && res.success) {
                this.toastr.success(res.success);
                this.teamName = '';
                this.getTeam();
            }
        })
    }
    getTeam() {
        this.editorService.createAndGetTeam(
            {
                "uid": this.uid,
                "type": "get"
            }
        ).subscribe(res => {
            if (!!res && res.error) {
                this.toastr.error(res.error)
            }
            if (!!res && res.teams) {
                this.teams = res.teams
            }
        })
    }
    deleteFullTeam(teamId: string) {
        this.editorService.deleteTeam(
            {
                "uid": this.uid,
                "tid": teamId
            }
        ).subscribe(res => {
            if (!!res && res.error) {
                this.toastr.error(res.error)
            }
            if (!!res && res.success) {
                this.toastr.success(res.success);
                this.getTeam();
                // this.teams = res.teams
            }
        })
    }
    removeUser(userId: string,tid:string) {
        this.editorService.removeTeamMember({
            "uid": this.uid,
            "tid": tid,
            "teamUserId": userId
        }).subscribe(res=>{
            if(!!res && !!res.error){
                this.toastr.error(res.error);
            }
            if(!!res && !!res.success){
                this.toastr.success(res.success)
                this.getTeam();
            }
        })
    }
}